import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AbstractCallComponent } from '../abstract-call/abstract-call.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { InputEntryConfig } from '@se/platform';

@Component({
    selector: 'se-form-call',
    templateUrl: './form-call.component.html',
    styleUrls: ['../call-style/call.scss'],
})
export class FormCallComponent extends AbstractCallComponent implements OnInit, AfterViewInit {
    form = new FormGroup({});
    inputListConfig: InputEntryConfig[] = [];

    constructor() {
        super();
    }

    ngAfterViewInit(): void {
        /*verificare se si puo saltare lo step perche abbiamo gia tutti i dati*/
        if (this.call.formConfig?.skipOnPreFill && this.areAllInputsPreFilled()) {
            return this.done();
        }
    }

    ngOnInit() {
        super.ngOnInit();
        this.prepareInputListConfig();
        this.createForm();
    }

    areAllInputsPreFilled = ():boolean => {
        return this.inputListConfig.every(input => {
            return input.initialValue !== null && input.initialValue !== undefined;
        });
    };

    prepareInputListConfig = () => {
        this.inputListConfig = this.call.formConfig?.inputList.map(inputConfig => {

            if (!inputConfig.sourceDataPath) return inputConfig;

            const sourceData = Array.isArray(this.dataStore[inputConfig.sourceDataPath]) ?
                [...this.dataStore[inputConfig.sourceDataPath] as any[]] : [];

            let initialValue = inputConfig.initialValue ?? '';
            if (['select', 'multi-select'].includes(inputConfig.inputType)) {
                initialValue = sourceData.length ? sourceData[0] : null;
            }

            return { ...inputConfig, initialValue, sourceData };
        }) || [];
    };

    createForm = () => {
        this.call.formConfig?.inputList.forEach((input, idx) => {
            let initialValue = input.initialValue ?? '';
            if (['select', 'multi-select'].includes(input.inputType)) {
                initialValue = this.inputListConfig[idx].sourceData[0];
            }

            this.form.addControl(input.name, new FormControl(initialValue, {
                nonNullable: Boolean(input.nonNullable),
                validators: input.required ? [Validators.required] : [],
            }));
        });
    };

    done = () => {
        this.result = this.form.getRawValue();
        this.end();
    };

}
